module.exports = __webpack_public_path__ + "media/images/prediction/special/nagai_hiratsuka/btn_hochi_off-047f5348cbf923cf4e1b9835263c894c.gif";